import { Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../models/response.model'
import {
  FornecedorMotoristaRegister,
  FornecedorVeiculoRegister,
} from '../../models/supplier-portal.model'

// TG operando em nome do fornecedor (perfis 1, 2, 3, 6) quando ele não preenche a OS —
// mesmas regras de negócio do Portal do Fornecedor (FornecedorPortalService), mas quem
// executa é o operador interno, então o fornecedor precisa ser sempre explícito por
// {fornecedorId} na URL. Exceção: as duas rotas de atribuição na OS deduzem o fornecedor
// da própria OS no servidor — nunca mandar fornecedorId nelas.
@Injectable({
  providedIn: 'root',
})
export class FornecedorGestaoService {
  private baseUrl = environment.baseUrl
  private resource = 'FornecedorGestao'

  constructor(private httpClient: HttpClient) {}

  // Atribuição na OS
  public atribuirMotorista(osId: string, motoristaId: number): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/ordens-servico/${osId}/motorista?motoristaId=${motoristaId}`,
      {},
    )
  }

  public atribuirVeiculo(osId: string, veiculoId: string): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/ordens-servico/${osId}/veiculo?veiculoId=${veiculoId}`,
      {},
    )
  }

  // Motoristas de um fornecedor
  public listPagedMotoristas(
    fornecedorId: number,
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/fornecedores/${fornecedorId}/motoristas/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public getMotoristaByCpf(fornecedorId: number, cpf: string): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/fornecedores/${fornecedorId}/motoristas/por-cpf/${cpf}`,
    )
  }

  // Find-or-create: se o CPF já existe na base, só vincula ao fornecedor e atualiza CNH —
  // não existe rota separada de "vincular" aqui como no Portal do Fornecedor.
  public createMotorista(
    fornecedorId: number,
    model: FornecedorMotoristaRegister,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/fornecedores/${fornecedorId}/motoristas`,
      model,
    )
  }

  // Veículos de um fornecedor
  public listPagedVeiculos(
    fornecedorId: number,
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/fornecedores/${fornecedorId}/veiculos/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public createVeiculo(
    fornecedorId: number,
    model: FornecedorVeiculoRegister,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/fornecedores/${fornecedorId}/veiculos`,
      model,
    )
  }
}
